import { getriderlist } from '../../api';

export const NAMESPACE = 'riderList';

export const UPDATE_LIST = `UPDATE_LIST_${NAMESPACE}`;
export const UPDATE_CURRENTPAGE = `UPDATE_CURRENTPAGE_${NAMESPACE}`;
export const UPDATE_PAGINATION = `UPDATE_PAGINATION_${NAMESPACE}`;
export const UPDATE_SEARCH_CONDITION = `UPDATE_SEARCH_CONDITION_${NAMESPACE}`;
export const UPDATE_STATUS = `UPDATE_STATUS_${NAMESPACE}`;
export const UPDATE_STATUS_LIST = `UPDATE_STATUS_LIST_${NAMESPACE}`;
export const RESET_ALL = `RESET_ALL_${NAMESPACE}`;

const s = {
  list: [],
  currentPage: 1,
  pagination: {
    total: 0,
    perpage: 50,
  },
  searchCondition: {
    rider_id: '',
    rider_name: '',
  },
  workStatus: [],
  riderStatusList: [],
};

const getters = {
};

const actions = {
  handleSelectWorkStatus({ commit, dispatch }, status) {
    commit(UPDATE_STATUS, status);
    dispatch('getRiderListData');
  },
  resetRiderListData({ commit }) {
    commit(RESET_ALL);
  },
  handleCurrentPageChange({ commit, dispatch }, page) {
    commit(UPDATE_CURRENTPAGE, page);
    dispatch('getRiderListData');
  },
  getRiderListData({ commit, state, rootState, rootGetters }, condition) {
    const { timestamp } = rootState;
    const { AoiShopMsg } = rootGetters;
    const { currentPage, pagination, workStatus } = state;
    if (AoiShopMsg) {
      const params = {
        time: timestamp,
        aoi_id: AoiShopMsg.aoi_id,
        shop_id: AoiShopMsg.shop_id,
        perpage: pagination.perpage,
        page: currentPage,
        work_status: workStatus.length > 0 ? workStatus.join(',') : null,
      };
      getriderlist({
        ...params,
        ...condition,
      }).then((data) => {
        if ((data.errno === 0 || data.errno === '0') && data.data) {
          commit(UPDATE_PAGINATION, {
            ...state.pagination,
            total: data.data.total,
          });
          if (data.data.list) {
            commit(UPDATE_LIST, data.data.list);
          }
          if (data.data.status) {
            const status = [];
            const selected = [];
            Object.keys(data.data.status)
              .forEach((key) => {
                status.push({ label: key, value: data.data.status[key] });
                selected.push(data.data.status[key]);
              },
              );
            commit(UPDATE_STATUS_LIST, status);
          }
        }
      });
    }
  },
};

const mutations = {
  // eslint-disable-next-line no-unused-vars
  [RESET_ALL](state) {
    state.pagination = {
      total: 0,
      perpage: 50,
    };
    state.list = [];
    state.riderStatusList = [];
    state.currentPage = 1;
  },
  [UPDATE_LIST](state, payload) {
    state.list = payload;
  },
  [UPDATE_CURRENTPAGE](state, payload) {
    state.currentPage = payload;
  },
  [UPDATE_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [UPDATE_SEARCH_CONDITION](state, payload) {
    state.searchCondition = payload;
  },
  [UPDATE_STATUS_LIST](state, payload) {
    state.riderStatusList = payload;
  },
  [UPDATE_STATUS](state, payload) {
    state.workStatus = payload.includes(0) ? [0] : payload;
  },
};

export default {
  namespaced: true,
  state: s,
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/pages/homepage/store/modules/riderList.js